import deleteSvg from '../../assets/images/svg/deleteSvg.svg';
import alertIcon from '../../assets/images/svg/alertSvg.svg';
import crossIcon from '../../assets/images/svg/crossSvg.svg';
import linkIcon from '../../assets/images/svg/linkSvg.svg';
import infoIcon from '../../assets/images/svg/infoSvg.svg';
import editIcon from '../../assets/images/svg/editSvg.svg';

export const FILE_SHARING_SETTINGS = {
  SVG: {
    DELETE: deleteSvg,
    ALERT: alertIcon,
    CROSS: crossIcon,
    LINK: linkIcon,
    INFO: infoIcon,
    EDIT: editIcon,
  },
};

export const appCode = 'sm';

export const appName = 'lp-le-social-management';

export const instagramConfigName = 'instagramConfiguration';

export const facebookConfigName = 'facebookConfiguration';

export const INSTAGRAM_TERMS_OF_USE = 'msggw.instagram.termsOfUse';

export const INSTAGRAM_WIDGET_STATUS = 'socialmessaging.connectors.instagram.widget.enabled';
export const INSTAGRAM_SITE_SETTING = 'social.settings.instagram';
export const FACEBOOK_SITE_SETTING = 'social.settings.facebook';
export const TWITTER_SITE_SETTING = 'social.settings.twitter';

export const fbSDKv = 'v17.0';

export const fbGraphAPIURL = `https://graph.facebook.com/${fbSDKv}`;

export const SELF_SERVICE_URL = {
  TWITTER: '/mc/feature/twitter',
  INSTAGRAM: '/mc/feature/instagram',
  FACEBOOK: '/mc/feature/facebook',
};

export const ConnectorType = {
  FACEBOOK: 'FacebookConnector',
  INSTAGRAM: 'InstagramConnector',
  TWITTER: 'TwitterConnector',
};

export const ConnectorTypeId = {
  FACEBOOK: 102,
  INSTAGRAM: 115,
};
